import { CommonModule } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { UiModule } from '@components/ui/ui-module';
import { CardBinder, CardCondition } from '@models/binder.model';
import { Lang, Variante } from '@models/card.model';
import { Global } from '@services/global.service';

@Component({
  selector: 'lgb-update-card',
  imports: [
    FormsModule,
    CommonModule,
    UiModule
  ],
  templateUrl: './update-card.html',
  styleUrl: './update-card.css',
})
export class UpdateCard {
  //service
  readonly global=inject(Global);

  //data
  readonly card=input.required<CardBinder>();
  readonly update=output<boolean>();
  readonly langs=Lang.getLangs();
  readonly conditions=signal<CardCondition[]>([]);
  readonly variantes=signal<Variante[]>([]);

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);
    this.global.init()
      .pipe(
        takeUntilDestroyed()
      )
      .subscribe(response => {
        this.variantes.set(response.variantes);
        this.conditions.set(response.conditions);
        this.loading.set(false);
      });
  }

}
